
import request from '@/utils/request';

const baseURLAdmin = process.env.VUE_APP_ADMIN;
// const baseURLAddress = process.env.VUE_APP_ADDRESS;

// 大区配置————分页
export const regionPage = (data) => {
  return request({
    method: 'post',
    url: '/region/config/page',
    data,
    baseURL: baseURLAdmin
  });
};

// 大区配置————获取网点数据
export const getSiteBySiteType = (data) => {
  return request({
    method: 'post',
    url: '/site/getSiteBySiteType',
    data,
    baseURL: baseURLAdmin
  });
};

// 大区配置————新增
export const regionAdd = (data) => {
  return request({
    method: 'post',
    url: '/region/config/add',
    data,
    baseURL: baseURLAdmin
  });
};

// 大区配置————编辑
export const regionUpdate = (data) => {
  return request({
    method: 'post',
    url: '/region/config/update',
    data,
    baseURL: baseURLAdmin
  });
};

// 大区配置————删除
export const regionDelete = (data) => {
  return request({
    method: 'post',
    url: '/region/config/delete',
    data,
    baseURL: baseURLAdmin
  });
};
